import { defineComponent as _defineComponent } from 'vue'
interface Props {
    extra?: string;
    customClass?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseList',
  props: {
    extra: null,
    customClass: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})